import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n,r=``)=>{let{data:i}=await t.post(`/users/${n}/re-invite`,{scope:e(r)});return i};export{t as reInviteUser};
//# sourceMappingURL=re-invite-users.mjs.map